export default async function concatBipartidos(racksInfo) {
    // Função para obter a parte de nscala antes do "/"
    const getBaseNscala = (nscala) => nscala.split('/')[0];
    
    // Percorrer cada rack (chave numérica) no objeto principal
    for (const rack in racksInfo) {
        const items = racksInfo[rack];
        const nscalaMap = {};
        const indicesToRemove = new Set(); // Armazena os índices que serão removidos

        // Primeiro, mapear os valores de nscala
        items.forEach((item, index) => {
            // Inicializa o campo rackSelected, será utilizado para criar lista de objetos que montará o card com infos do rack
            item.rackSelected = [{
                rackName: item.nscala,
                classification: item.classification,
                cage: item.cage,
                clientName: item.clientName,
                ocupacao: item.ocupacao,
                potenciaConsumida: item.potenciaConsumida,
                potenciaContratada: item.potenciaContratada,
                reserved: item.reserved,
                status: item.status,
                pdu: item.pduRacks
            }];

            const baseNscala = getBaseNscala(item.nscala);

            if (!nscalaMap[baseNscala]) {
                nscalaMap[baseNscala] = [index]; // Se não existir, inicializa o array
            } else {
                nscalaMap[baseNscala].push(index); // Se já existir, adiciona o índice
            }
        });

        // Agora, concatenar os valores dos objetos que compartilham a mesma base de nscala
        for (const baseNscala in nscalaMap) {
            const indices = nscalaMap[baseNscala];

            if (indices.length > 1) {
                // Primeiro objeto onde será feita a concatenação
                const mainItem = items[indices[0]];

                // Percorrer os itens seguintes e concatenar com ","
                for (let i = 1; i < indices.length; i++) {
                    const currentItem = items[indices[i]];

                    // Verificar se `currentItem` tem `nscala`, `client` e `nrack`
                    if (!currentItem || !currentItem.nscala || !currentItem.client || !currentItem.nrack) {
                        console.error("Objeto inválido encontrado:", currentItem);
                        continue; // Pula para o próximo item se `currentItem` for `undefined`
                    }

                    mainItem.nscala += `, ${currentItem.nscala}`;
                    mainItem.client.client += `, ${currentItem.client.client}`;
                    mainItem.nrack += `, ${currentItem.nrack}`; // Concatena o campo "nrack"

                    // Adicionando o rackSelected do currentItem ao mainItem e vice-versa
                    mainItem.rackSelected.push(...currentItem.rackSelected);
                    currentItem.rackSelected.push(...mainItem.rackSelected.filter(rs => !currentItem.rackSelected.includes(rs)));

                    // Adiciona o índice do item atual ao conjunto de remoção
                    indicesToRemove.add(indices[i]);
                }
            }
        }

        // Remover os itens que não são `mainItem`
        items.forEach((_, index) => {
            if (indicesToRemove.has(index)) {
                items[index] = null; // Marca o item para remoção
            }
        });

        // Filtra os itens para remover os marcados como `null`
        racksInfo[rack] = items.filter(item => item !== null);
    }

    return racksInfo;
}